import React from "react";

import "./TStatus.css"

export default function TStatus (props) {
  return(
    <span className="ts-status">
      <span className="ts-status-label">{props?.label}&nbsp;</span>
      <span className="ts-status-numerator">{props?.numerator}</span>
      <span className="ts-status-denom">/{props?.denom}</span>
    </span>
  )
}
